import { IdentityDto } from './../shared';
import { EntityDto } from './../entity';

import { MerchantIdentifierDto } from './../merchant-identifiers';

import { ChannelAccountType } from '@nx-ws/bhn-enums/channel/channel-account-type.enum';

export class ChannelDto {
  identity: IdentityDto;
  entity: EntityDto;
  account?: string;
  channelAccountType: ChannelAccountType;
  category?: string;
  legalEntity?: string;
  type?: string;
  merchantIdentifiers?: MerchantIdentifierDto[];

  constructor(d?: ChannelDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);

    this.identity = new IdentityDto(d.identity);
    this.entity = new EntityDto(d.entity);

    if (d.merchantIdentifiers) {
      this.merchantIdentifiers = d.merchantIdentifiers.map(
        i => new MerchantIdentifierDto(i)
      );
    }
  }
}
